import Button from "components/shared/Button";

const mainClass = `syndicated-footer__call-to-action`;

const FooterCallToAction = ({ title, webLinkList }) => {
	return (
		<div className={mainClass}>
			{title && (
				<h5
					className={`${mainClass}__title`}
					dangerouslySetInnerHTML={{ __html: title }}
				></h5>
			)}
			<div className={`${mainClass}__container`}>
				{webLinkList?.map((link, index) => (
					<Button
						key={link.analyticsId || index}
						link={true}
						linkContent={{ ...link }}
						secondary={index !== 0}
						className={`${mainClass}__button`}
					></Button>
				))}
			</div>
		</div>
	);
};

export default FooterCallToAction;
 